<script>
/**
 * ****************************************************************************
 * @description     :   MainMenu
 * @created at      :   2022/03/24
 * @created by      :   ANS809 – quypn@ans-asia.com
 * @package         :   Best Security
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */
/**
 * Import libraries
 */
import { mapState, mapMutations } from 'vuex';

/**
 * import template
 */
import template from './template.html';

/**
 * Define main layout
 */
const MainMenu = {
    name: 'Menu',
    template: template,
    data() {
        return {
            activeIndex: -1,
            isShowBackdrop: false
        };
    },
    computed: {
        ...mapState('app', ['menus', 'isShowMenu'])
    },
    watch: {
        isShowMenu(isShow) {
            if (!isShow) {
                setTimeout(() => {
                    this.isShowBackdrop = false;
                }, 300);
            } else {
                this.isShowBackdrop = true;
            }
        },
        menus() {
            const index = this.getActiveIndex();
            setTimeout(() => {
                this.setActiveIndex(index);
            }, 300);
        }
    },
    methods: {
        ...mapMutations('app', ['hideMenu']),
        setActiveIndex(idx) {
            const oldIndex = this.activeIndex;
            this.activeIndex = this.activeIndex === idx ? -1 : idx;
            if (this.activeIndex > -1) {
                const div = document.getElementById('divChildMenu' + idx);
                if (div) {
                    div.setAttribute(
                        'style',
                        `height: ${
                            48 + this.menus[idx].childMenus.length * 32
                        }px`
                    );
                }
            }
            const div = document.getElementById('divChildMenu' + oldIndex);
            if (div) {
                div.setAttribute('style', 'height: 0px');
            }
        },
        getActiveIndex() {
            const length = this.menus.length;
            const pathname =
                window.location.pathname === '/'
                    ? ''
                    : window.location.pathname;
            let pathnameDetail = pathname;
            if (
                pathname.length > 1 &&
                pathname.substring(pathname.length - 1, pathname.length) === 'i'
            ) {
                pathnameDetail =
                    pathname.substring(0, pathname.length - 1) + 'l';
            }
            let index = -1;
            for (let i = 0; i < length; i++) {
                const countChild = this.menus[i].childMenus.length;
                if (countChild > 0) {
                    for (let j = 0; j < countChild; j++) {
                        if (
                            this.menus[i].childMenus[j].screenurl ===
                                pathname ||
                            this.menus[i].childMenus[j].screenurl ===
                                pathnameDetail
                        ) {
                            index = i;
                            this.menus[i].childMenus[j].isActive = true;
                            return index;
                        }
                    }
                } else {
                    if (
                        this.menus[i].screenurl === pathname ||
                        this.menus[i].screenurl === pathnameDetail
                    ) {
                        this.menus[i].isActive = true;
                        index = i;
                    }
                }
                if (index > -1) {
                    return index;
                }
            }
            return index;
        },
        setIsActive(item) {
            const length = this.menus.length;
            for (let i = 0; i < length; i++) {
                const countChild = this.menus[i].childMenus.length;
                if (countChild > 0) {
                    for (let j = 0; j < countChild; j++) {
                        this.menus[i].childMenus[j].isActive = false;
                    }
                } else {
                    this.menus[i].isActive = false;
                }
            }
            item.isActive = true;
        }
    }
};
export default MainMenu;
</script>
